import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import PropTypes from 'prop-types';
import React from 'react';
import { View, ViewPropTypes, StyleSheet } from 'react-native';
import Avatar from './Avatar';
import Bubble from './Bubble';
import SystemMessage from './SystemMessage';
import Day from './Day';
import { isSameUser } from './utils';
var styles = {
  left: StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'flex-start',
      marginLeft: 8,
      marginRight: 0
    }
  }),
  right: StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
      marginLeft: 0,
      marginRight: 8
    }
  })
};

var Message =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Message, _React$Component);

  function Message() {
    _classCallCheck(this, Message);

    return _possibleConstructorReturn(this, _getPrototypeOf(Message).apply(this, arguments));
  }

  _createClass(Message, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var next = nextProps.currentMessage;
      var current = this.props.currentMessage;
      var _this$props = this.props,
          previousMessage = _this$props.previousMessage,
          nextMessage = _this$props.nextMessage;
      var nextPropsMessage = nextProps.nextMessage;
      var nextPropsPreviousMessage = nextProps.previousMessage;
      var shouldUpdate = this.props.shouldUpdateMessage && this.props.shouldUpdateMessage(this.props, nextProps) || false;
      return next.sent !== current.sent || next.received !== current.received || next.pending !== current.pending || next.createdAt !== current.createdAt || next.text !== current.text || next.image !== current.image || next.video !== current.video || next.audio !== current.audio || previousMessage !== nextPropsPreviousMessage || nextMessage !== nextPropsMessage || shouldUpdate;
    }
  }, {
    key: "renderDay",
    value: function renderDay() {
      if (this.props.currentMessage && this.props.currentMessage.createdAt) {
        var _this$props2 = this.props,
            containerStyle = _this$props2.containerStyle,
            props = _objectWithoutProperties(_this$props2, ["containerStyle"]);

        if (this.props.renderDay) {
          return this.props.renderDay(props);
        }

        return React.createElement(Day, props);
      }

      return null;
    }
  }, {
    key: "renderBubble",
    value: function renderBubble() {
      var _this$props3 = this.props,
          containerStyle = _this$props3.containerStyle,
          props = _objectWithoutProperties(_this$props3, ["containerStyle"]);

      if (this.props.renderBubble) {
        return this.props.renderBubble(props);
      }

      return React.createElement(Bubble, props);
    }
  }, {
    key: "renderSystemMessage",
    value: function renderSystemMessage() {
      var _this$props4 = this.props,
          containerStyle = _this$props4.containerStyle,
          props = _objectWithoutProperties(_this$props4, ["containerStyle"]);

      if (this.props.renderSystemMessage) {
        return this.props.renderSystemMessage(props);
      }

      return React.createElement(SystemMessage, props);
    }
  }, {
    key: "renderAvatar",
    value: function renderAvatar() {
      var _this$props5 = this.props,
          user = _this$props5.user,
          currentMessage = _this$props5.currentMessage,
          showUserAvatar = _this$props5.showUserAvatar;

      if (user && user._id && currentMessage && user._id === currentMessage.user._id && !showUserAvatar) {
        return null;
      }

      if (currentMessage && currentMessage.user.avatar === null) {
        return null;
      }

      var _this$props6 = this.props,
          containerStyle = _this$props6.containerStyle,
          props = _objectWithoutProperties(_this$props6, ["containerStyle"]);

      return React.createElement(Avatar, props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          currentMessage = _this$props7.currentMessage,
          nextMessage = _this$props7.nextMessage,
          position = _this$props7.position,
          containerStyle = _this$props7.containerStyle;

      if (currentMessage) {
        var sameUser = isSameUser(currentMessage, nextMessage);
        return React.createElement(View, null, this.renderDay(), currentMessage.system ? this.renderSystemMessage() : React.createElement(View, {
          style: [styles[position].container, {
            marginBottom: sameUser ? 2 : 10
          }, !this.props.inverted && {
            marginBottom: 2
          }, containerStyle && containerStyle[position]]
        }, this.props.position === 'left' ? this.renderAvatar() : null, this.renderBubble(), this.props.position === 'right' ? this.renderAvatar() : null));
      }

      return null;
    }
  }]);

  return Message;
}(React.Component);

export { Message as default };
Message.defaultProps = {
  renderAvatar: undefined,
  renderBubble: null,
  renderDay: null,
  renderSystemMessage: null,
  position: 'left',
  currentMessage: {},
  nextMessage: {},
  previousMessage: {},
  user: {},
  containerStyle: {},
  showUserAvatar: false,
  inverted: true,
  shouldUpdateMessage: undefined
};
Message.propTypes = {
  renderAvatar: PropTypes.func,
  showUserAvatar: PropTypes.bool,
  renderBubble: PropTypes.func,
  renderDay: PropTypes.func,
  renderSystemMessage: PropTypes.func,
  position: PropTypes.oneOf(['left', 'right']),
  currentMessage: PropTypes.object,
  nextMessage: PropTypes.object,
  previousMessage: PropTypes.object,
  user: PropTypes.object,
  inverted: PropTypes.bool,
  containerStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style
  }),
  shouldUpdateMessage: PropTypes.func
};